import { NavItem, styled, NavItemProps, cssVar } from '@cad-arc';
import { NavLink } from '../fr-navigation';

const StyledNavItem = styled(NavItem)<{ isActive: boolean }>`
    border: 1px solid
        ${({ isActive }) => (isActive ? cssVar('arc.colors.selected.default') : 'transparent')};
    margin-top: 0;
    margin-bottom: 8px;

    & svg {
        width: 24px;
        height: 24px;
    }
`;

type FrNavItemProps = NavItemProps & {
    to: string;
};

export function FrNavItemLink({ to, ...props }: FrNavItemProps) {
    return (
        <NavLink to={to}>
            {({ isActive }) => <StyledNavItem {...props} isActive={isActive} />}
        </NavLink>
    );
}
